export enum BorderClass {
  top = 'square--border_top',
  right = 'square--border_right',
  bottom = 'square--border_bottom',
  left = 'square--border_left',
  thickTop = 'square--border-thick_top',
  thickRight = 'square--border-thick_right',
  thickBottom = 'square--border-thick_bottom',
  thickLeft = 'square--border-thick_left'
}
